import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('prepopulating_a_demo_organisation_with_sample_data'),
    description: defineMessage('we_noticed_that_you_hav_ompany_with_sample_data'),
    prepopulateData: defineMessage('yes_prepopulate_with_sample_data'),
    notPrepopuluteData: defineMessage('no_i_will_set_up_everything_myself'),
};
